import { type ViewedElementTrackerList } from '@/features/shared/services/ViewedElementTracker/constants'
import {
  useMutationIncrementViewedElementTracker,
  useMutationOptOutViewedElementTracker,
} from '@/features/shared/services/ViewedElementTracker/mutations'
import { viewedElementTrackerQueryOptions } from '@/features/shared/services/ViewedElementTracker/queries'
import { trackViewedTrackerIncremented } from '@/features/shared/services/ViewedElementTracker/utils'
import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

export const useCanShowViewType = (viewTypeName: ViewedElementTrackerList) => {
  const { mutateAsync } = useMutationIncrementViewedElementTracker()
  const { mutateAsync: optOutOfView } = useMutationOptOutViewedElementTracker()
  const queryClient = useQueryClient()
  const viewedElementTrackerResponse = queryClient.getQueryData(
    viewedElementTrackerQueryOptions.queryKey,
  )
  const viewedElementTracker = viewedElementTrackerResponse?.[viewTypeName]

  const setHaveSeenThis = useCallback(() => {
    if (viewedElementTracker?.view_type_id) {
      trackViewedTrackerIncremented({
        canShowPopupModal: Boolean(viewedElementTracker.should_show),
        elementName: viewedElementTracker.type_name,
      })
      mutateAsync(viewedElementTracker.view_type_id)
    }
  }, [mutateAsync, viewedElementTracker])

  const getLatestHaveSeenThis = useCallback(() => {
    const view = queryClient.getQueryData(viewedElementTrackerQueryOptions.queryKey)?.[viewTypeName]
    return Boolean(view?.should_show)
  }, [queryClient, viewTypeName])

  const optOutOfViewEarly = useCallback(() => {
    if (viewedElementTracker?.view_type_id) {
      optOutOfView(viewedElementTracker.view_type_id)
    }
  }, [optOutOfView, viewedElementTracker])

  return [
    Boolean(viewedElementTracker?.should_show),
    setHaveSeenThis,
    getLatestHaveSeenThis,
    optOutOfViewEarly,
  ] as const
}
